import { Moon, Sun } from 'lucide-react'
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'alerte-immo:theme'

function readInitialTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light'
  return (window.localStorage.getItem(STORAGE_KEY) as 'light' | 'dark') ?? 'light'
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<'light' | 'dark'>(readInitialTheme)

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    window.localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  return (
    <button
      type="button"
      onClick={() => setTheme((t) => (t === 'light' ? 'dark' : 'light'))}
      className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border bg-surface text-muted hover:text-foreground transition-colors"
      aria-label={theme === 'light' ? 'Activer le mode sombre' : 'Activer le mode clair'}
    >
      {theme === 'light' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  )
}
